import { Field } from "formik"
import AddressGeocode from 'Ui/AddressGeocode'

interface FormattedGeocodeAddress {
  formattedAddress: string
  address: string
  cp: string
  city: string
  country: string
}

interface Props {
  onlyFrance: boolean,
  allowDomiciliationAddresses: boolean,
  touched: any
  errors: any
  fieldOptions: {
    key: string
    label: string
    title?: string
    subtitle?: string
    additionnalActionOnChange?: (address: any) => void
    additionnalActionOnSelect?: (formatted: FormattedGeocodeAddress) => void
  }
  setValues: (values: (prevValues: any) => any) => void
  setFieldValue: (field: string, value: any) => void
  setFieldError: (field: string, message: string | null) => void
  setFieldTouched: (field: string, touched: boolean, shouldValidate?: boolean) => void
}

// custom validation to check if user hasn't modified activity location text input after selecting an address in the list
// can be used automatically with our validators helper with 'geocode-address'
export const addressGeocodeValidation = (values: any, fieldKey: string) => {
  const value = values[fieldKey]
  const validationValue = values[`${fieldKey}_validation`]

  console.log('value --------------------------------->')
  console.log(value)
  console.log(validationValue)

  if (!value) { // input is empty
    return 'Merci d’indiquer une adresse.'
  }

  if (!validationValue) { // user hasn't selected an address from the suggestions (or no suggestions has been displayed yet)
    return 'Merci d’indiquer une adresse et de sélectionner une des suggestions proposées.'
  }

  if (value !== validationValue) { // user has modified the input after selecting an address
    return 'Adresse non valide'
  }

  return null
}

/*
  Wrapper around AddressGeocode component to use it with Formik
  To use it, in the Formik form initialValues, we must add a field with the field name + '_validation'
*/
const AddressGeocodeFormikWrapper = ({
  onlyFrance = false,
  allowDomiciliationAddresses = false,
  touched,
  errors,
  fieldOptions,
  setValues,
  setFieldError,
  setFieldValue,
  setFieldTouched,
}: Props) => {
  const { key, label, title, subtitle, additionnalActionOnChange, additionnalActionOnSelect } = fieldOptions

  const onSelect = (formatted: FormattedGeocodeAddress) => {
    setValues((prevValues : any) => ({
      ...prevValues,
      [key]: formatted.formattedAddress,
      [`${key}_validation`]: formatted.formattedAddress,
    }))
    if (additionnalActionOnSelect) {
      additionnalActionOnSelect(formatted)
    }
  }

  return (
    <div className="input">
      {title && <h2 className={`step-title${subtitle ? ' mb-3' : ''}`}>{title}</h2>}
      {subtitle && <p className="step-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />}
      <Field
        key={key}
        name={key}
        className="Input-group"
        placeholder={label}
        component={AddressGeocode}
        onlyFrance={onlyFrance}
        allowDomiciliationAddresses={allowDomiciliationAddresses}
        onChange={(value: string) => { // this is when user types in the input
          setFieldValue(key, value)
          if (additionnalActionOnChange) {
            additionnalActionOnChange(value)
          }
        }}
        onSelect={onSelect} // this is when user selects an address from the suggestions
        onError={(error: string | null) => {
          setFieldError(key, error)
          setFieldTouched(key, true, false)
        }}
      />
      <span className="input-error-message">{(touched[key] && errors[key]) || ''}</span>
    </div>
  )
}

export default AddressGeocodeFormikWrapper